import React, { FC } from 'react';

interface PropTypes{
  className?: string
}

export const IconLeftDiff : FC<PropTypes> = ({className}) => <i className={`fas fa-chevron-circle-right me-2 ${className ? className : ""}`} />

